import * as React from "react";
import { Alert } from "@trussworks/react-uswds";
import { Typography } from "@mui/material";
import { fetchData } from "../services/ApiClient";
import { ApiBaseUrl, AppUrl } from "../../config";
import { KeyStringValue } from "../../interfaces";
import LeavingFDICDialog from "../../components/LeavingFDICDialog";
import { Link } from "react-router-dom";
interface Props {
  updateBanner: (banner: string) => void;
  updateUi: (uiField: string, uiValue: string | undefined) => void;
}
const textToLink = (text: string) => {
  const regex = /\[(.*?)\]/g;
  const parts = text.split(regex);
  return (
    <Typography
      style={{
        font: "Source Sans Pro",
        fontSize: 16,
        paddingBottom: 0,
        marginLeft: 50,
      }}
    >
      {parts.map((part: string, index: number) => {
        if (index % 2 === 1) {
          const regex2 = /\{(.*?)\}/g;
          const link = part.split(regex2);

          return !link[1]?.includes("https") ? (
            <Link key={link[0]} to={AppUrl(link[1])}>
              {link[0]}
            </Link>
          ) : (
            <LeavingFDICDialog
              key={link[0]}
              webAddress={link[1]}
              label={link[0]}
              noHover
              styles={{
                font: "Source Sans Pro",
                fontSize: 16,
                paddingBottom: 0,
                display: "inline",
              }}
            />
          );
        }
        return part;
      })}
    </Typography>
  );
};

export default function CloudFoundryBanner({ updateBanner, updateUi }: Props) {
  const [bannerState, setBannerState] = React.useState<KeyStringValue[]>([
    { is_active: "", title: "", description: "" },
  ]);

  React.useEffect(() => {
    let isMounted = true;
    (async () => {
      await fetchData(`${ApiBaseUrl()}/maintenance`)
        .then((response) => {
          if (isMounted) {
            setBannerState(response?.data);
            updateBanner(response?.data?.[0]?.disable_content);
            if (response?.data?.[0]?.pending_closed) {
              updateUi(
                "pendingClosedBanks",
                response?.data?.[0].pending_closed,
              );
            }
          }
        })
        .catch((error: Error) => {
          console.error(error);
        });
    })();
    return () => {
      isMounted = false;
    };
  }, [updateBanner, updateUi]);

  return bannerState && bannerState?.[0]?.is_active === "true" ? (
    <Alert type={"info"} headingLevel="h4" style={{ marginBottom: 16 }}>
      {bannerState?.[0]?.title && (
        <Typography
          style={{
            fontFamily: "Source Sans Pro",
            fontSize: 24,
            lineHeight: ".9",
            marginTop: 0,
            marginBottom: " 0.5rem",
            fontWeight: "bold",
            marginLeft: 50,
          }}
        >
          {bannerState?.[0]?.title}
        </Typography>
      )}
      {textToLink(bannerState?.[0]?.description)}
    </Alert>
  ) : null;
}
